import firebase from '../services/firebase';

export function setDeliveryUrl(partner) {
  const url = new URL(window.location.href);
  url.searchParams.set('openDelivery', 'true');
  window.history.replaceState(null, null, url);
  firebase.analytics().logEvent(`${partner}_click`);
}
